import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { keysToCamel } from '#/api/adapters/wireCase';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * GET `/ims/stocktake/comparison`。
 * list／page 走 Ver4；根層 `compared_at`（若有）一併回傳。
 */
export async function fetchStocktakeComparison(listQuery) {
  const { data: raw } = await request.get('/ims/stocktake/comparison', {
    params: listQueryToApiParams(listQuery),
  });
  const parsed = parseVer4ListResponse(raw);
  const meta = keysToCamel({
    comparedAt: raw?.compared_at ?? raw?.comparedAt ?? null,
  });

  return {
    ...parsed,
    comparedAt: meta.comparedAt ?? null,
  };
}
